<template>
  <div class="ma-4">
    <!-- <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar> -->
    <ClientNav />
    <v-row>
    <v-col cols="12" lg="3" xl="2">
      <ClientSide />
    </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <div v-if="page == 'Main'">
            <v-btn @click="page = 'Completed'">Completed Agreements</v-btn>
            <v-card height="665">
              <h1 class="font-weight-thin ml-4">Agreements and Consents</h1>
              <v-autocomplete
                class="pa-4"
                label="Select an Agreement"
                :items="agreements"
              ></v-autocomplete>
            </v-card>
          </div>

          <div v-if="page == 'Completed'">
            <v-btn @click="page = 'Main'">Back</v-btn>
            <h1>Completed</h1>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <Foot />
  </div>
</template>
<script>
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: function() {
    return {
      agreements: [
        "A. Authorization for Emergency Medical Aid",
        "B. Medical Treatment Consent Form",
        "C. Medical/Medication Assistance",
        "D. Request and Authorization for Test Results and/or Medical Records",
        "E. Authorization to Release Information",
        "F. Change Report Form",
        "G. Consent to Receive Services",
        "H. Human Rights and Grievance Procedure",
        "I. Loan to Client Authorization",
        "J. myCase Authorization to Release Information",
        "K. Release of Information",
        "L. Release of Non-Medical Information",
        "M. Voluntary Financial Support Agreement",
      ],
      page: "Main",
    };
  },
};
</script>
